<div fxLayout="column" fxLayoutAlign="start stretch" class="video-player-container"
	[ngClass]="{'fullscreen-mode': fullscreen}" (contextmenu)="preventContext($event)" #videoContainer>
	<div class="video-player" fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch">
		<!-- <loader [loader]="loader" [type]="'general'"></loader> -->
		<div class="video-block" [ngClass]="{'cursor-pointer': isDesktop}" fxFlex="1 1" fxLayoutAlign="center center"
			#videoBlock>
			<ng-container *ngIf="!loaded">
				<div class="ratio-content" (click)="loadVideo()">
					<img class="video-img" [src]="thumbnail" alt="" (error)="gfService.setErrorImage($event, 'broken_image')">
					<div class="overlay-controls" fxLayoutAlign="center stretch">
						<div fxLayoutAlign="center center" class="overlay-play" fxFlex="80px">
							<ng-container *ngIf="canStartPlay">
								<mat-icon class="buzz-effect">play_arrow</mat-icon>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="loaded">
				<video class="ratio-content" #videoEl (dblclick)="doubleClick()" (click)="togglePlay('video')">
					<source [src]="source" type="video/mp4">
				</video>
				<div class="overlay-controls" fxLayoutAlign="space-between stretch" (dblclick)="doubleClick()"
					(click)="togglePlay('video')">
					<div fxLayoutAlign="center center" fxFlex="1 1" class="overlay-rewind" (click)="overlayBackward()">
						<ng-container *ngIf="!hideSkipBackward">
							<div class="rippler" fxLayoutAlign="end center" @skipTransition
								(@skipTransition.done)="skipBackwardTransitDone()" [@.disabled]="isDesktop">
								<span class="timer buzz-effect">
									-10s
								</span>
							</div>
						</ng-container>
					</div>
					<div fxLayoutAlign="center center" class="overlay-play" fxFlex="80px">
						<ng-container *ngIf="loader">
							<mat-spinner diameter="80"></mat-spinner>
						</ng-container>
						<ng-container
							*ngIf="!loader && videoNativeEl?.duration !== videoNativeEl?.currentTime && !hidePlayPause && hideSkipForward && hideSkipBackward">
							<mat-icon class="buzz-effect" @playPauseTransition (@playPauseTransition.done)="transitDone()"
								[@.disabled]="!isDesktop" (click)="togglePlayForMobile('icon')">
								{{(isPlaying) ? 'pause' : 'play_arrow'}}
							</mat-icon>
						</ng-container>
						<ng-container
							*ngIf="!loader && videoNativeEl?.duration === videoNativeEl?.currentTime && !hidePlayPause && hideSkipForward && hideSkipBackward">
							<mat-icon class="buzz-effect" @playPauseTransition (@playPauseTransition.done)="transitDone()"
								[@.disabled]="!isDesktop" (click)="togglePlayForMobile('icon')">
								replay
							</mat-icon>
						</ng-container>
					</div>
					<div fxLayoutAlign="center center" fxFlex="1 1" class="overlay-forward" (click)="overlayForward()">
						<ng-container *ngIf="!hideSkipForward">
							<div class="rippler" fxLayoutAlign="start center" @skipTransition
								(@skipTransition.done)="skipForwardTransitDone()" [@.disabled]="isDesktop">
								<span class="timer buzz-effect">
									+10s
								</span>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
		</div>
		<ng-container *ngIf="loaded">
			<div class="controller" fxFlex="0 0" fxLayout="column" fxLayoutAlign="start stretch"
				[@fade]="((hideControl && fullscreen) || !canPlay) ? 'out' : 'in'" (mouseover)="overOnControl()"
				(mouseleave)="leaveControl()">
				<div class="control-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px"
					[@fade]="(hideControl) ? 'out' : 'in'">
					<div class="progress-block">
						<div class="progress-bar" fxLayoutAlign="start center">
							<div class="progress-basebar" #seekBarEl (mousemove)="onProgressBarMouseMove($event)"
								(mouseover)="onProgressBarMouseOver($event)" (mouseleave)="onProgressBarMouseLeave($event)"
								(mousedown)="seekBarMouseDown($event)">
								<div class="seek-bar" fxLayoutAlign="start center">

									<div class="pointer-overlay" #progressTooltipEl>
										<div class="pointer-duration">
											{{duration}}
										</div>
									</div>

									<div class="progress-buffer" id="bufferProgress" #bufferEl></div>
									<div class="video-player-progress" id="playerProgress" #playerProgressEl>
									</div>

									<ng-container
										*ngIf="bookMarksData?.length && bookMarksData[currentBookmarkIndex] && showBookmarkPagination">
										<ng-container *ngFor="let bookmark of bookMarksData[currentBookmarkIndex]?.timelineData">
											<div class="progress-band" [style]="{'--position-left':bookmark?.progress + '%'}"></div>
										</ng-container>
									</ng-container>

								</div>
							</div>
							<div class="progress-pointer" #playerPointerEl draggable="true"
								(mouseover)="onProgressBarMouseOver($event)" (mousedown)="pointerMouseDown($event)"
								(mouseleave)="onProgressBarMouseLeave($event)">
							</div>
						</div>
					</div>

					<div class="controls" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap.xs="5px">
						<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayoutGap.xs="10px">
							<ng-container *ngIf="videoNativeEl?.duration !== videoNativeEl?.currentTime && isDesktop">
								<button mat-icon-button class="icon-play" type="button" (click)="togglePlay('icon')">
									<mat-icon>
										{{(isPlaying) ? 'pause' : 'play_arrow'}}
									</mat-icon>
								</button>
							</ng-container>

							<ng-container *ngIf="videoNativeEl?.duration === videoNativeEl?.currentTime && isDesktop">
								<button mat-icon-button class="icon-play" type="button" (click)="replay()">
									<mat-icon>
										replay
									</mat-icon>
								</button>
							</ng-container>

							<div fxLayoutAlign="center center">
								<ng-container *ngIf="totalDuration">
									<p class="time">{{videoElapsedTime}} / {{totalDuration}}</p>
								</ng-container>
							</div>
							<ng-container *ngIf="options?.skip">
								<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0px"
									[ngStyle]="{'display': (!isDesktop || deviceDetails?.deviceType === 'mobile') ? 'none' : 'block'}">
									<button mat-icon-button [disabled]="videoNativeEl?.currentTime <= 0" type="button"
										(click)="backward()">
										<mat-icon svgIcon="rewind" matTooltip="-10s" matTooltipPosition="above"></mat-icon>
									</button>
									<button mat-icon-button [disabled]="videoNativeEl?.currentTime >= videoNativeEl?.duration"
										type="button" (click)="forward()">
										<mat-icon svgIcon="forward" matTooltip="+10s" matTooltipPosition="above"></mat-icon>
									</button>
								</div>
							</ng-container>
						</div>

						<ng-container
							*ngIf="bookMarksData?.length && showBookmarkPagination && bookMarksData[currentBookmarkIndex]?.timelineData?.length">
							<div fxFlex="0 0 auto" fxFlex.xs="1 1" class="active-bookmark" fxLayout="row"
								fxLayoutAlign="center center" fxLayoutGap="0px">
								<div fxFlex="0 0 auto">
									<button class="navigation" type="button" mat-icon-button [disabled]="currentTimelineIndex === 0"
										(click)="changeBookmark('before')">
										<mat-icon>arrow_back_ios</mat-icon>
									</button>
								</div>
								<app-chips fxFlex="0 0 auto" fxFlex.xs="1 1" class="active-grand-chip" type="grand" [removable]="true"
									(removed)="removeBookMarkSelection($event)"
									[data]="{title: bookMarksData[currentBookmarkIndex]?.caption}">
								</app-chips>
								<div fxFlex="0 0 auto">
									<button class="navigation" type="button" mat-icon-button
										[disabled]="currentTimelineIndex === (bookMarksData[currentBookmarkIndex]?.timelineData?.length - 1)"
										(click)="changeBookmark('after')">
										<mat-icon>arrow_forward_ios</mat-icon>
									</button>
								</div>
							</div>
						</ng-container>

						<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0px" class="additional-controls">
							<div [ngStyle]="{'display': !isDesktop ? 'none' : 'block'}" class="controls-items volume-control"
								(mouseover)="onVolumeMouseOver($event)" (mouseleave)="onVolumeMouseLeave($event)">
								<button mat-icon-button type="button" (click)="mute()">
									<mat-icon>{{(videoNativeEl?.muted) ? 'volume_off' : 'volume_up'}}</mat-icon>
								</button>
								<div class="ranger" fxLayoutAlign="center center" #volumeControlEl>
									<div class="volume-bar" #volumeBarEl (mousedown)="volumeControl($event)">
										<div class="volume-progress" #volumeProgressEl></div>
									</div>
									<div class="progress-pointer" #volumePointerEl draggable="true"
										(mousedown)="volumePointerMouseDown($event)"></div>
								</div>
							</div>
							<ng-container *ngIf="options?.fullscreen">
								<div class="controls-items">
									<button mat-icon-button type="button" (click)="toggleScreen()">
										<mat-icon>{{(fullscreen) ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
									</button>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
				<ng-container *ngIf="bookMarksData?.length">
					<div class="expansion-views" fxLayout="row" fxLayoutAlign="space-between start">
						<div class="feature-list" fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="0px" #bookmarkEl
							[@accordionY]="(showExtraBookmark) ? ((expanded) ? 'on' : 'off') : ''">
							<ng-container *ngFor="let bookmark of bookMarksData; let i = index">
								<!-- <div (click)="currentBookmarkIndex = i; showBookmarkPagination = true;setBookmarkTime(bookmark.timelineData[0]); currentTimelineIndex = 0;"> -->
								<app-chips type="grand" class="feature-item" [data]="{title: bookmark?.caption}"
									(chipInfo)="currentBookmarkIndex = i; showBookmarkPagination = true;setBookmarkTime(bookmark.timelineData[0]); currentTimelineIndex = 0;">
								</app-chips>
								<!-- </div> -->
							</ng-container>
						</div>
						<ng-container *ngIf="showExtraBookmark">
							<button mat-icon-button (click)="showMoreBookmarks()">
								<mat-icon class="icon-drop">{{ (expanded) ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
							</button>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</ng-container>
	</div>
</div>
